import React,{Component} from 'react'

export default class url extends Component
{
    //static baseURL="http://127.0.0.1:8000/api";
    // static mediaURL="http://127.0.0.1:8000";
    static baseURL="https://admin.thegoproject.me/api";
    static mediaURL="https://admin.thegoproject.me/";
}